var CacheItem, Promise, STATUS;

Promise = require('bluebird');

STATUS = {
  initialized: "initialized",
  fetching: "fetching",
  fetched: "fetched",
  fetchFailed: "fetch failed"
};

module.exports = CacheItem = (function() {
  function CacheItem(opts) {
    this.key = opts.key;
    this.value = opts.value;
    this.fetchFunction = opts.fetchFunction;
    this.init();
  }

  CacheItem.prototype.init = function(status) {
    if (status == null) {
      status = STATUS.initialized;
    }
    this._status = status;
    this.resolvers = [];
    return this.rejectors = [];
  };

  CacheItem.prototype.fetch = function() {
    return Promise["try"]((function(_this) {
      return function() {
        var p;
        if (_this._status === STATUS.fetchFailed) {
          _this.init();
        }
        if (_this._status === STATUS.fetched || !_this.fetchFunction) {
          return _this.value;
        }
        p = new Promise(function(resolve, reject) {
          _this.resolvers.push(resolve);
          return _this.rejectors.push(reject);
        });
        if (_this._status === STATUS.initialized) {
          _this._status = STATUS.fetching;
          Promise["try"](function() {
            return _this.fetchFunction(_this.key);
          }).then(function(value) {
            var i, len, r, ref, results;
            _this.value = value;
            _this._status = STATUS.fetched;
            ref = _this.resolvers;
            results = [];
            for (i = 0, len = ref.length; i < len; i++) {
              r = ref[i];
              results.push(r(value));
            }
            return results;
          })["catch"](function(err) {
            var i, len, r, ref, results;
            _this._status = STATUS.fetchFailed;
            ref = _this.rejectors;
            results = [];
            for (i = 0, len = ref.length; i < len; i++) {
              r = ref[i];
              results.push(r(err));
            }
            return results;
          })["finally"](function() {
            return _this.init(_this._status);
          });
        }
        return p;
      };
    })(this));
  };

  return CacheItem;

})();
